<template>
  <aside :style="{ backgroundColor: corporateBrandColor }" class="main-sidebar elevation-4 sidebar-dark-primary">

    <router-link :to="userDefaultRoute" class="brand-link pb-0">
      <img
          :height="headerLogo.height"
          :src="headerLogo.icon"
          :width="headerLogo.width" alt class="brand-image mx-auto"
      />
    </router-link>

<!--    <router-link :to="headerLogo.to" class="brand-link pt-0 pb-2">-->
<!--      <p class="brand-text font-weight-bold mx-auto mb-0">{{ getCorporateName }}</p>-->
<!--    </router-link>-->

    <div class="text-center mb-2" v-if="plan">
      <b-badge :variant="plan.variant">{{ plan.name }}</b-badge>
    </div>

    <div class="corporate-name">
      <p class="admin-portal-label mb-0"> Admin Portal </p>
      <span class="badge badge-success ">BETA</span>
      <p v-if="activeTheme" class="theme-type-label text-uppercase">{{ activeTheme }}</p>
    </div>
    <div class="sidebar">
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-accordion="false" data-widget="treeview" role="menu">
          <NavItem v-for="item in navList" v-if="!item.hidden" :menu-item="item" />
        </ul>
      </nav>
    </div>

    <div class="bottom-sidebar sidebar">
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-accordion="false" data-widget="treeview" role="menu">
          <NavItem v-for="item in bottomNavList" :menu-item="item" />
        </ul>
      </nav>
    </div>

    <router-link :to="footerLogo.route" class="brand-link">
      <img :height="footerLogo.height" :src="footerLogo.icon" :width="footerLogo.width" alt class="brand-image mx-auto" />
    </router-link>
  </aside>
</template>
<script>
import {createNamespacedHelpers, mapState} from "vuex";
import { dashboardMixin } from "@/module_dashboard/mixins";
import FooterLogo from "@/assets/elitefit-logo-white.png";
import NavItem from "./MenuItem";
import defaultRoutes from "@/utils/defaultRoutes";
import roles from "@/utils/roles";
import {permissionsMixin} from "@/utils/accessPermission.js"
const {
  mapGetters: mapThemeGetters
} = createNamespacedHelpers("themes");

export default {
  name: "Sidebar",
  mixins: [dashboardMixin,permissionsMixin ],
  components: {
    NavItem
  },
  data() {
    return {
      userDefaultRoute: defaultRoutes[roles.USER],
      assessment: false
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapThemeGetters(["activeTheme", "theme", "pages"]),
    config() {
      const config = this.$store.state?.userInfo?.corporate?.config || {};
      return {
        hideChallenge: true,
        hideProgram: !!config?.hideProgram,
      }
    },
    lang(){
      return localStorage.getItem('lang') || 'en'
    },
    navList() {
        return [
        {
          name: "Dashboard",
          iconName: "Dashboard",
          route: {
            name: "AnalyticsDashboard"
          },
          hidden : !this.hasAccessPermission("dashboard")
        },
        {
          name:this.lang == 'en' ?  "Video <br> Management" : "Video Management",
          iconName: "Videos",
          route: {
            name: !this.$store.state?.userInfo?.corporate?.subscription?.allow_video_upload && 
          this.config.hideChallenge && this.config.hideProgram ?'VideoManagementLibrary' : "VideoManagement",
        },
          hidden : (!this.hasAccessPermission("elitefit_library") && !this.hasAccessPermission("view_programs") && !this.hasAccessPermission("view_videos")) || this.userInfo?.corporate?.theme === 'assessment',
          children: !this.$store.state?.userInfo?.corporate?.subscription?.allow_video_upload &&
          this.config.hideChallenge && this.config.hideProgram ? []: [
            {
              name: "EliteFit.AI Library",
              route: {
                name: "VideoManagementLibrary"
              },
              hidden : !this.hasAccessPermission("elitefit_library")
            },
            {
              name: "Your Videos",
              route: {
                name: "VideoManagementList"
              },
              hidden: !this.hasAccessPermission("view_videos") || !this.$store.state?.userInfo?.corporate?.subscription?.allow_video_upload || false
            },
            {
              name: "Set " + this.theme[this.pages.SMB_CHALLENGES].name,
              route: {
                name: "AnalyticsChallenges"
              },
              hidden: this.config.hideChallenge
            },
            {
              name: "Set " + this.theme[this.pages.SMB_PROGRAMS].name,
              route: {
                name: "AnalyticsProgram"
              },
              hidden: !this.hasAccessPermission("view_programs") ||  this.config.hideProgram
            },
            {
              name: 'Assignment',
              route: {
                name: "AssignProgramChallenge"
              },
              hidden: true
            },
            {
              name: 'Create and Assign',
              route: {
                name: "CreateAssignProgram"
              },
              hidden: true
            }
          ]
        },
        {
          name: this.lang == 'en' ? this.theme[this.pages.SMB_USERS_SECTION].name : this.theme[this.pages.SMB_USERS_SECTION].name.replace("<br>", ""),
          iconName: "Users",
          route: {
            name: "UserManagement",
          },
          hidden : !this.hasAccessPermission("view_users") && !this.hasAccessPermission("view_admins") && !this.hasAccessPermission("view_teams"),
          children: [
            {
              name: this.theme[this.pages.SMB_USERS].name + "s",
              route: {
                name: "UsersManagement"
              },
              hidden : !this.hasAccessPermission("view_users") && !this.hasAccessPermission("view_admins")
            },
            {
              name: this.theme[this.pages.SMB_TEAMS].name + "s",
              route: {
                name: "TeamsManagement"
              },
              hidden : !this.hasAccessPermission("view_teams")
            },
          ]
        },
        {
          name: "Analytics",
          iconName: "Analytics",
          route: {
            name: "AnalyticsSection",
          },
          hidden : !this.hasAccessPermission("view_reports") || this.userInfo?.corporate?.theme === 'assessment',
          children: [
            {
              name: this.theme[this.pages.SMB_REPORT].name,
              route: {
                path :this.userInfo.corporate.theme === 'physiotherapy' ? "/management/analytics/patient-report" :"/management/analytics/reports" 
                // name: "AnalyticsReports"
              },
              hidden : !this.hasAccessPermission("view_reports")
            },
             {
              name: this.theme[this.pages.AI_REPORT].name,
              route: {
                name: "AiAdminReport"
              },
              hidden : !this.$store.state?.userInfo?.corporate?.config?.showAIReports ?? false
            },
          ]
        },
        {
          name: "Notifications",
          iconName: "Notifications",
          route: {
            name: "Notifications"
          },
          hidden: !this.$store.state?.userInfo?.corporate?.config?.showNotifications ?? true
        },
        {  
          name: "Achievement",
          iconName: "Achievement",
          route: {
            name: "AchievementManagement"
          },
          hidden : !this.userInfo?.corporate?.config?.showAchievements ?? true
        },
        {
          name: "Assessment",
          iconName: "Analytics",
          route: {
            name: "Assessments"
          },
          // hidden : !this.userInfo?.corporate?.config?.is_assessment,
          children: [
            {
              name: 'Physio Assessments',
              route: {
                path :"/assessment" 
              },
            },
            {
              name: 'FSB Assessments',
              route: {
                path :"/fsb-assessment" 
              },
            },
          ]
        },
        // {
        //   name: "Billing",
        //   iconName: "Billing",
        //   route: {
        //     name: "AdminBillingHistory"
        //   }
        // }
      ]
    },
    bottomNavList() {
      return [
        {
          name: "Settings",
          iconName: "Settings",
          route: {
            path: "/management/microsite?update=update",
          },
          children: []
        },
        {
          name: "Support Ticket",
          iconName: "Tickets",
          route: {
            path: 'https://forms.monday.com/forms/20e51e1050e0269083a0749fa3cde559?r=use1',
          },
          children: []
        },
        // {
        //   name: "Tutorial",
        //   iconName: "Tutorial",
        //   route: {
        //     name: "",
        //   },
        //   children: []
        // },
      ]
    },
    headerLogo() {
      return {
        icon: this.corporateLogo,
        route: this.corporateHomePageRoute,
        width: '96px',
        height: '96px',
      }
    },
    footerLogo() {
      return {
        icon: FooterLogo,
        route: {
          name: "Main"
        },
        width: '96px',
        height: '96px',
      }
    },
    plan() {
      const subscription = this.userInfo?.corporate?.subscription;
      if (!subscription || subscription.is_free) {
        return {
          name: "Free",
          variant: "light"
        };
      }
      return {
        name: subscription.name,
        variant: "primary"
      };
    }
  },
  mounted() {
    this.assessment = !this.userInfo?.corporate?.config?.is_assessment;
  }
}
</script>
<style lang="scss" scoped>
@import "@/module_dashboard/styles/admin_lte.scss";

.corporate-name {
  position: relative;
  display: flex;
  flex-direction: column;
  .badge {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 10px;
    transform: translate(-25%, 0);
  }
  .theme-type-label {
    font-size: 11px;
    line-height: 20px;
    border: 1px solid #8DC63F;
    color: #8DC63F;
    border-radius: 12px;
    padding: 0 8px;
    margin: 0 5px;
  }
}

.nav-icon {
  margin-right: 0.8rem !important;
}

.main-sidebar {
  display: flex;
  flex-direction: column;
}

.brand-link {
  display: flex;
  align-items: center;
  border: 0px !important;

  .brand-image {
    transition: all 0.3s ease-in-out;
    height: 56px;
    max-height: 56px;
  }
}

.admin-portal-label{
  font-weight: bold;
  color: white;
  text-align: center;
  font-size: 1.5rem;
}

.corporate-name {
  transition: all 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.sidebar-mini.sidebar-collapse {
  .brand-image {
    height: 33px;
    max-height: 33px;
  }

  .bottom-sidebar {
    .nav-sidebar {
      margin-left: 0rem;
    }
  }

  .corporate-name {
    display: none;
  }

  .main-sidebar:hover {
    .brand-image {
      height: 56px;
      max-height: 56px;
    }

    .bottom-sidebar {
      .nav-sidebar {
        margin-left: 1rem;
      }
    }

    .corporate-name {
      display: flex;
    }
  }

}

.sidebar-dark-primary .nav-sidebar>.nav-item>.nav-link.active {
  background-color: transparent !important;
  color: #73bc44 !important;

  path {
    fill: #73bc44;
  }
}

.bottom-sidebar.sidebar {
  display: flex;
  flex-direction: column-reverse;
  height: 35%;
}

.bottom-sidebar {
  .nav-sidebar {
    margin-left: 1rem;
    transition: margin-left 0.3s ease-in-out;
  }
}

.Dashboard-item{
  border-radius: .2rem;
}

.Dashboard-item:hover{
  background-color: rgba(255, 255, 255, 0.1);
  cursor: pointer;

  span{
    color: white;
  }
}

.Dashboard-item.active:hover{
  cursor: pointer;
  background-color: transparent;

  span{
    color: #73bc44;
  }
}
</style>
